import { ProcessingRuleType } from '@/modules/HealthPlan/HealthPlan.types.ts';

const { AGGREGATE_ONLY, EMBEDDED_ONLY, COMBINED } = ProcessingRuleType;

export { AGGREGATE_ONLY, EMBEDDED_ONLY, COMBINED };

export const CARD_PURSE_LOCK = 'LOCK';
export const CARD_PURSE_UNLOCK = 'UNLOCK';
export const LOCK_CARD_PURSE_KEY = 'lockCardPurse';
export const PLAN_IDS_FOR_CARD_PURSE_LOCK_KEY = 'planIdsForCardPurseLock';
